import { LOGO_URL, CONTACT } from "../lib/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--ms-ink)] text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Top row */}
        <div className="grid grid-cols-12 gap-8 pb-14 border-b border-white/10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Marketing Sublime" className="w-12 h-12 object-contain" />
              <div className="flex flex-col leading-none">
                <span className="font-display font-semibold text-[16px] tracking-tight">marketing</span>
                <span className="font-display font-semibold text-[16px] tracking-tight text-[var(--ms-lila)] -mt-0.5">sublime</span>
              </div>
            </div>
            <p className="mt-6 font-body text-sm leading-relaxed text-white/55 max-w-md">
              Diseñamos ecosistemas de marca que conectan emocionalmente con el consumidor. Una agencia 360° donde la estética se fusiona con la estrategia.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-body text-[10px] uppercase tracking-[0.28em] text-white/45 mb-4">
              Navegación
            </div>
            <ul className="flex flex-col gap-2.5 font-body text-sm text-white/85">
              <li><a href="#nosotros" className="hover:text-[var(--ms-lila)] transition">Nosotros</a></li>
              <li><a href="#mision-vision" className="hover:text-[var(--ms-lila)] transition">Misión &amp; Visión</a></li>
              <li><a href="#servicios" className="hover:text-[var(--ms-lila)] transition">Servicios</a></li>
              <li><a href="#distintivos" className="hover:text-[var(--ms-lila)] transition">Distintivos</a></li>
              <li><a href="#contacto" className="hover:text-[var(--ms-lila)] transition">Contacto</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div className="font-body text-[10px] uppercase tracking-[0.28em] text-white/45 mb-4">
              Contacto
            </div>
            <ul className="flex flex-col gap-2.5 font-body text-sm text-white/85">
              <li>{CONTACT.telefono}</li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[var(--ms-lila)] transition">
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-white/55 leading-relaxed text-xs pt-2">
                {CONTACT.direccion}
              </li>
            </ul>
          </div>
        </div>

        {/* Watermark */}
        <div className="pt-14 pb-4 select-none">
          <h3 className="font-display font-medium text-[18vw] md:text-[16vw] lg:text-[14vw] leading-none tracking-[-0.05em] text-transparent"
              style={{ WebkitTextStroke: "1px rgba(163,112,175,0.35)" }}
          >
            sublime.
          </h3>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-6 border-t border-white/10">
          <span className="font-body text-xs text-white/45">
            © {new Date().getFullYear()} Marketing Sublime. Todos los derechos reservados.
          </span>
          <span className="font-body text-xs text-white/45">
            Guadalajara, Jalisco · México
          </span>
        </div>
      </div>
    </footer>
  );
}
